export default defineNuxtRouteMiddleware((to, from) => {
  const profile = useProfileStore();
  const { getContentPathFromId } = useContentsHelper();
  // list of all vacation book's ids
  const vacationBookIds = [
    '63074a1f4bb1de6d7cef4412',
    '630e2eabaac3bb645f620f8f',
    '630e3443aac3bb645f620fae',
    '630e367d89218d6482eea4d5',
    '630e37f189218d6482eea516',
  ];

  if (profile.plansId !== '6687ae36bc913722c43a1e68') return;

  if (profile.isParent && profile.family.members.length === 1) {
    return navigateTo('/famille/cahier-de-vacances', { redirectCode: 301 });
  } else if (
    from.path === '/mon-compte/ajouter-un-membre' &&
    profile.familyMembers.length === 2
  ) {
    // check if one of parents's content id is a cdv is
    const content = profile.contents.find((content) => {
      return vacationBookIds.includes(content.id);
    });
    if (content) {
      const url = getContentPathFromId(content.id);
      return navigateTo(url, { redirectCode: 301 });
    }
  }
});
